import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const currentUserStore = atomWithStorage('currentUser', '');
export const jwtStore = atomWithStorage('jwt', '');
export const profileStore = atomWithStorage('profile', '');
export const isEmployeeStore = atomWithStorage('isEmployee', false);



export const currentPageStore = atom('/');